/*
 * @Author: linguang linguang@nextmar.com
 * @Date: 2025-01-20 10:00:00
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-06-23 17:25:38
 * @FilePath: /zeelool-nextjs/src/api/activity.ts
 * @Description: Activity related API functions
 */
import { httpRequest } from '@/utils/axios';
import type { ApiParamsDefinition } from './types/api-definition';

/** 使用入站邀请参数完成归因，认证由现有请求层携带。 */
export const completeLotteryInvitation = (
  data: ApiParamsDefinition['POST:/api/activity/lottery-tool/invite-complete']['data'],
) =>
  httpRequest(
    'POST:/api/activity/lottery-tool/invite-complete',
    { data },
    { success: false, fail: false },
  );

// 大使报名接口
export const addAmbassadorCollaboration = (data: {
  name: string;
  phone: string;
  phoneCode: string;
  business_email: string;
  influencer_info: Array<{
    account_name: string;
    handle: string;
  }>;
}) => httpRequest('POST:/api/public/add_ambassador_collaboration', { data });

// 大使列表接口
export const getAmbassadorList = (params: {
  page?: number;
  limit?: number;
  ambassador_area_id?: any;
}) => httpRequest('GET:/api/public/ambassadors', { params });

// 大使领域列表接口
export const getAmbassadorField = () => httpRequest('GET:/api/public/ambassador_areas');

// 大使作品列表接口
export const getAmbassadorWorks = (params: {
  ambassador_id?: string[];
  limit?: number;
  page?: number;
  ambassador_work_id?: string[];
}) => httpRequest('GET:/api/public/ambassador_works', { params });

// 大使作品详情接口
export const getAmbassadorWorkDetail = (id: string) =>
  httpRequest('GET:/api/public/ambassador_works/{id}', { id });
